import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "pencil_svg__icon pencil_svg__icon--pencil"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.593 0a4.389 4.389 0 0 1 3.126 1.279l.002.002a4.387 4.387 0 0 1-.039 6.232L8.185 22.01a.75.75 0 0 1-.344.196l-6.905 1.77a.75.75 0 0 1-.912-.912l1.77-6.905a.75.75 0 0 1 .196-.344L16.487 1.318A4.389 4.389 0 0 1 19.593 0Zm2.067 2.34a2.89 2.89 0 0 0-4.104.03l-.006.006L3.196 16.73 1.79 22.21l5.479-1.405L21.63 6.443a2.887 2.887 0 0 0 .03-4.102Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.136 1.73a.75.75 0 1 0-1.06 1.06l5.134 5.135a.75.75 0 0 0 1.06-1.061L17.136 1.73ZM3.05 15.814a.75.75 0 0 0-1.059 1.061l5.14 5.13a.75.75 0 1 0 1.059-1.061l-5.14-5.13Z"
  })));
};

export { SvgPencil as default };
//# sourceMappingURL=pencil.svg.js.map
